module.exports = __webpack_public_path__ + "assets/img/ceremonyBg.243a5ff7.png";